import { isPlainObject } from 'lodash-es';

export function shallowArrayMaybe(value) {
  return Array.isArray(value) ? [...value] : value;
}

export function shallowObjectMaybe(value) {
  return isPlainObject(value) ? { ...value } : value;
}

export function shallowObjectOrEmpty(value) {
  return isPlainObject(value) ? { ...value } : {};
}
